import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@montugroup/design-system';

import { REQUEST_CONFIRMATION_MESSAGE } from '../common';

type RequestConfirmationDialogProps = {
  open: boolean;
  onClose?: () => void;
  onSendRequest: () => void;
  loading?: boolean;
};

export default function RequestConfirmationDialog({
  open,
  onClose,
  onSendRequest,
  loading,
}: RequestConfirmationDialogProps) {
  return (
    <Dialog open={open}>
      <DialogTitle>Confirm your request</DialogTitle>
      <DialogContent>
        <DialogContentText>{REQUEST_CONFIRMATION_MESSAGE}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onClose} data-testid="undo-request">
          Go back
        </Button>
        <Button data-testid="continue" onClick={onSendRequest} loading={loading} color="primary" variant="contained">
          Send request
        </Button>
      </DialogActions>
    </Dialog>
  );
}
